'use client';

import { Typography } from '@/components/Typography';
import { useVehicleCompareState } from './VehicleCompareContext';

export function StickyListTitle() {
    const { categories, categoryCount } = useVehicleCompareState();

    return categories.length > 0 ? (
        <Typography className="w-full max-w-none p-0 text-[20px] md:text-[24px]" as="h4" variant="h4">
            Comparison ({categoryCount}/{categories.length})
        </Typography>
    ) : null;
}
